const calculateCartSum = (cart) => {
  let sum = cart.donations || 0;
  let tickets = cart.tickets;
  let bar = cart.bar;
  if (tickets) {
    for (let ticket of tickets) {
      sum += Number(ticket.price);
    }
  }

  if (bar) {
    for (let barItem of bar) {
      sum += Number(barItem.price) * Number(barItem.count);
    }
  }

  return sum;
};

export default calculateCartSum
